import { HospitalIndemnityPlanType } from "../generated/graphql";

export enum Condition {
    SICKNESS,
    INJURY,
    SICKNESS_AND_INJURY
}

const conditionDescriptionByCondition = new Map([
    [Condition.SICKNESS, 'Sickness'],
    [Condition.INJURY, 'Injury'],
    [Condition.SICKNESS_AND_INJURY, 'Sickness/Injury']
])

const conditionByPlanType = new Map([
    [HospitalIndemnityPlanType.SicknessOnly, Condition.SICKNESS],
    [HospitalIndemnityPlanType.InjuryOnly, Condition.INJURY],
    [HospitalIndemnityPlanType.SicknessAndInjury, Condition.SICKNESS_AND_INJURY]
])

export namespace Condition {
    export function findConditionDescriptionFor(condition: Condition) {
        return conditionDescriptionByCondition.get(condition)
    }

    export function findConditionFromPlanTypeFor(planType: HospitalIndemnityPlanType): Condition {
        return conditionByPlanType.get(planType) as Condition
    }
}